export default __webpack_public_path__ + "static/media/ico-palette-black.e629a004.svg";